import { Component, inject } from '@angular/core';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppTitleStrategy } from '../../services/app-title.strategy';
import { AuthService } from '../../services/auth.service';
import { ThemeService } from '../../services/theme.service';
import { UserSessionService } from '../../services/user-session.service';
import { ConfirmationModal } from '../../shared/confirmation-modal/confirmation-modal';

@Component({
  selector: 'app-default-header',
  imports: [NgbDropdownModule],
  templateUrl: './default-header.component.html',
  styleUrl: './default-header.component.scss',
})
export class DefaultHeaderComponent {
  private readonly modal = inject(NgbModal);
  private readonly auth = inject(AuthService);
  protected readonly session = inject(UserSessionService);
  protected readonly theme = inject(ThemeService);
  protected readonly page = inject(AppTitleStrategy).page;

  async confirmLogout(): Promise<void> {
    const ref = this.modal.open(ConfirmationModal, { centered: true, size: 'sm' });
    Object.assign(ref.componentInstance, {
      title: 'Sign out',
      message: 'Are you sure you want to sign out?',
      confirmText: 'Sign out',
      icon: 'fa-right-from-bracket',
      variant: 'danger',
    });
    if (await ref.result.catch(() => false)) await this.auth.logout();
  }
}
